import { projectsData } from '../data/projects';

export const SITE_URL = 'https://neoappslab.com';
export const SITE_NAME = 'NeoApps';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/images/newlogo.png`;
export const DEFAULT_DESCRIPTION =
  'NeoApps builds modern websites and mobile apps for businesses. Android, iOS, and web development from Niš, Serbia.';

const staticPages = {
  '/': {
    title: 'NeoApps — Web & Mobile App Development | Niš, Serbia',
    description:
      'NeoApps designs and develops custom websites, Android apps, and iOS solutions. Web development, mobile apps, UI/UX design, and ongoing support for growing businesses.',
    keywords:
      'web development Serbia, mobile app development, Android apps, iOS apps, React development, NeoApps, Niš, software company',
  },
  '/about': {
    title: 'About NeoApps — Software Development Team',
    description:
      'Meet NeoApps — an independent software team from Niš building reliable websites and mobile applications with clean design and long-term value.',
    keywords: 'about NeoApps, software team Serbia, web agency Niš',
  },
  '/team': {
    title: 'Our Team — NeoApps Developers & Designers',
    description:
      'Meet the NeoApps team — developers, designers, and product specialists building web and mobile software for clients worldwide.',
    keywords: 'NeoApps team, developers Serbia, designers, mobile developers',
  },
  '/services': {
    title: 'Services — Web, Mobile, Design & Consulting | NeoApps',
    description:
      'NeoApps services: full-stack web development, native mobile apps, UI/UX design, backend APIs, maintenance, and technical consulting.',
    keywords: 'web development services, mobile app development, UI UX design, IT consulting Serbia',
  },
  '/portfolio': {
    title: 'Portfolio — Apps & Projects by NeoApps',
    description:
      'Explore NeoApps portfolio: Ski Serbia, My Passkeeper, Ski Jahorina, My Gym, NovalFlow, and other apps shipped to production.',
    keywords: 'NeoApps portfolio, mobile apps, Android projects, NovalFlow, case studies',
  },
  '/contact': {
    title: 'Contact NeoApps — Start Your Project',
    description:
      'Contact NeoApps for web and mobile development. Get a quote for your website, Android app, or iOS project. Based in Niš, Serbia.',
    keywords: 'contact NeoApps, get a quote, web development quote, app development Serbia',
  },
  '/404': {
    title: 'Page Not Found — NeoApps',
    description: DEFAULT_DESCRIPTION,
    keywords: 'NeoApps',
    noindex: true,
  },
};

const serviceTitles = {
  1: 'Full-Stack Web Development',
  2: 'Native Mobile Apps',
  3: 'Product Design',
  4: 'Scalable Backend Systems',
  5: 'Ongoing Support',
  6: 'Technical Consulting',
};

export const getCanonicalPath = (pathname) => {
  if (pathname === '/home') return '/';
  return pathname;
};

export const getSeoForPath = (pathname) => {
  const path = getCanonicalPath(pathname);
  const canonical = `${SITE_URL}${path === '/' ? '/' : path}`;

  if (staticPages[path]) {
    return { ...staticPages[path], canonical, path };
  }

  const projectMatch = path.match(/^\/project\/(\d+)$/);
  if (projectMatch) {
    const project = projectsData.find((item) => item.id === Number(projectMatch[1]));
    if (project) {
      return {
        title: `${project.title} — NeoApps Portfolio`,
        description: project.cardDescription || project.description.slice(0, 155),
        keywords: `${project.title}, NeoApps, mobile app, portfolio`,
        canonical,
        path,
      };
    }
  }

  const serviceMatch = path.match(/^\/services\/(\d+)$/);
  if (serviceMatch) {
    const title = serviceTitles[Number(serviceMatch[1])];
    if (title) {
      return {
        title: `${title} — NeoApps Services`,
        description: `Request a quote for ${title} from NeoApps. Web and mobile development from Niš, Serbia.`,
        keywords: `${title}, NeoApps services`,
        canonical,
        path,
      };
    }
  }

  return {
    title: 'NeoApps — Web & Mobile Development',
    description: DEFAULT_DESCRIPTION,
    keywords: 'NeoApps, web development, mobile apps',
    canonical,
    path,
    noindex: true,
  };
};
